import React from "react";
import Style from "../Home2.module.css";
import { useHistory } from "react-router-dom";
const DebitMemo = ({ factourCount }) => {
  const history = useHistory();
  return (
    <div className={Style.debtItemHolder} style={{ marginTop: "1rem" }}>
      <p>برای شما {factourCount} فاکتور اصلاحی وجود دارد!</p>
      <button
        className={Style.deptBtnPayHolder}
        onClick={() => history.push("/facturelist")}
      >
         صفحه فاکتور اصلاحی
      </button>
    </div>
  );
};

export default DebitMemo;
